import { render, staticRenderFns } from "./ScanRFIDButton.vue?vue&type=template&id=8ed2c254&scoped=true&"
import script from "./ScanRFIDButton.vue?vue&type=script&lang=js&"
export * from "./ScanRFIDButton.vue?vue&type=script&lang=js&"
import style0 from "./ScanRFIDButton.vue?vue&type=style&index=0&id=8ed2c254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed2c254",
  null
  
)

export default component.exports